export default __webpack_public_path__ + "static/media/2316.ebedaf8c.png";